import { render, staticRenderFns } from "./NavigationWidget.vue?vue&type=template&id=c2a0527e&scoped=true&"
import script from "./NavigationWidget.vue?vue&type=script&lang=js&"
export * from "./NavigationWidget.vue?vue&type=script&lang=js&"
import style0 from "./NavigationWidget.vue?vue&type=style&index=0&id=c2a0527e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2a0527e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';
installComponents(component, {VBtn,VIcon,VList,VListItem,VListItemTitle,VNavigationDrawer})
